// extracted by mini-css-extract-plugin
module.exports = {"ripple":"Loader_ripple__NVXL2"};